import {CreateAccessor, GetDoc, GetDocs} from "mobx-graphlink";
import {DMap} from "./maps/@Map.js";

export const GetMaps = CreateAccessor((): DMap[]=>{
	return GetDocs({}, a=>a.maps);
});
export const GetMap = CreateAccessor((id: string|n): DMap|n=>{
	return GetDoc({}, a=>a.maps.get(id!));
});